import { activeId, cycleAppWindows, exitWindowMode, focusWindow, windows } from '../../os/windows.svelte.js';
import { spacesState, switchSpace, toggleMissionControl } from '../../os/spaces.svelte.js';
import { portfolio } from '../../os/portfolio.svelte.js';

const defaults = {
  'mission-control': { key: 'ArrowUp', ctrl: true },
  'previous-space': { key: 'ArrowLeft', ctrl: true },
  'next-space': { key: 'ArrowRight', ctrl: true },
};

function shortcut(action) {
  return portfolio.settings.shortcuts?.[action] ?? defaults[action] ?? null;
}

function keyMatch(e, action) {
  const s = shortcut(action);
  if (!s) return false;
  if (e.key !== s.key && e.key.toLowerCase() !== s.key.toLowerCase()) return false;
  if (s.meta && !e.metaKey && !e.ctrlKey) return false;
  if (s.ctrl && !e.ctrlKey) return false;
  if (s.alt && !e.altKey) return false;
  if (s.shift && !e.shiftKey) return false;
  if (!s.meta && !s.ctrl && !s.alt && !s.shift) {
    return !e.metaKey && !e.ctrlKey && !e.altKey && !e.shiftKey;
  }
  return true;
}

export function handleDesktopKeydown(e) {
  if (e.key === 'Escape') {
    const id = activeId();
    if (id && exitWindowMode(id)) { e.preventDefault(); return; }
    if (spacesState.missionControlOpen) { e.preventDefault(); toggleMissionControl(); return; }
  }
  if ((e.metaKey || e.altKey) && e.key === '`') {
    const current = windows.find((win) => win.id === activeId());
    if (current?.appId) { e.preventDefault(); cycleAppWindows(current.appId, e.shiftKey ? -1 : 1); }
  }
  if (e.key === 'F3') { e.preventDefault(); toggleMissionControl(); }
  if (keyMatch(e, 'mission-control')) { e.preventDefault(); toggleMissionControl(); }
  if (keyMatch(e, 'previous-space')) {
    e.preventDefault();
    const idx = spacesState.spaces.findIndex(s => s.id === spacesState.activeSpaceId);
    if (idx > 0) switchSpace(spacesState.spaces[idx - 1].id);
  }
  if (keyMatch(e, 'next-space')) {
    e.preventDefault();
    const idx = spacesState.spaces.findIndex(s => s.id === spacesState.activeSpaceId);
    if (idx < spacesState.spaces.length - 1) switchSpace(spacesState.spaces[idx + 1].id);
  }
}
